import { create } from "zustand";

type Theme = "dark" | "light" | "system";

interface AppState {
  currentPage: string;
  theme: Theme;
  effectiveTheme: "light" | "dark";
  setCurrentPage: (value: string) => void;
  setTheme: (theme: Theme) => void;
  getEffectiveTheme: () => "light" | "dark";
}

export const useAppStore = create<AppState>((set, get) => ({
  currentPage: "dashboard",
  theme: (localStorage.getItem("vite-ui-theme") as Theme) || "dark",
  effectiveTheme: "dark",
  setCurrentPage: (value) => set({ currentPage: value }),
  setTheme: (theme) => {
    localStorage.setItem("vite-ui-theme", theme);
    const effectiveTheme = getEffectiveThemeValue(theme);
    set({ theme, effectiveTheme });

    // Update document classes
    const root = window.document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(effectiveTheme);
  },
  getEffectiveTheme: () => get().effectiveTheme,
}));

// Helper function to calculate effective theme
function getEffectiveThemeValue(theme: Theme): "light" | "dark" {
  if (theme === "system") {
    if (typeof window !== "undefined" && window.matchMedia) {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return "light";
  }
  return theme as "light" | "dark";
}

// Initialize the theme
if (typeof window !== "undefined") {
  const theme = (localStorage.getItem("vite-ui-theme") as Theme) || "dark";
  useAppStore.getState().setTheme(theme);
}
